import Link from 'next/link'
import { FaFilePdf } from 'react-icons/fa'

const ResourcesDownload = ({ mediaFiles }: any) => {
  return (
    <div className="w-[100px]  py-2 px-4">
      <div className="flex">
        {mediaFiles.map((file, i) => {
          return (
            <div className="mr-5">
              <div
                key={i}
                className="flex p-5 border items-center justify-center h-[180px]"
              >
                <p className="">
                  <Link href={file.url} target="_blank">
                    <FaFilePdf className="text-red-800" fontSize={120} />
                  </Link>
                </p>
              </div>
              <p className="mt-3 text-xs text-brand-dark text-center hover:underline ">
                <Link href={file.url} target="_blank">
                  {file.title}
                </Link>
              </p>
            </div>
          )
        })}
      </div>
      {/* <p className="text-xs font-semibold mt-5">
        A PDF viewer is required to view this product information
        <br />
        <a className="underline text-brand">Download PDF viewer here</a>
      </p> */}
    </div>
  )
}

export default ResourcesDownload
